import { Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { dataLockerLandingPageSelectedTabAtom } from '@/atoms/dataLocker/landingPage';

export const ExploreSavedFiltersText = () => {
  const { t } = useTranslation(['dataLocker', 'filters']);
  const selectedTab = useAtomValue(dataLockerLandingPageSelectedTabAtom);

  return (
    <>
      <Typography variant="headingRegular">{t('savedFilters', { ns: 'filters' })}</Typography>
      <Typography variant="bodyMedium" data-testid="saved-filters-description">
        {t(`landingPage.${selectedTab}.savedFiltersDescription`)}
      </Typography>
    </>
  );
};
